var _symbol, _symbol2, _clipPath, _symbol3, _clipPath2, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "material_x5F_system_x5F_icon_x5F_border",
    viewBox: "0 -48 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-48h48v48h-48z",
    fill: "none"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "material_x5F_system_x5F_icon_x5F_grid",
    viewBox: "-.0002 -48 48.0002 48.0002"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m2-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0-2h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-4h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-6h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-8h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-10h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-12h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-14h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-16h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-18h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-20h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-22h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-24h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-26h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-28h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-30h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-32h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-34h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-36h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-38h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-40h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-42h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-44h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-46h48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.75-.25v-47.5h-47.5v47.5zm.25.25h-48v-48h48z"
  })))))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "m0-48h48v48h-48z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "material_x5F_system_x5F_icon_x5F_keylines",
    viewBox: "-.0002 -48.0001 48.0002 48.0001"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m24 0v-48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m48-24h-48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m48-16h-48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m48-32h-48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m32-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m16-48v48",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m47.75-.25-47.5-47.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m.25-.25 47.5-47.5",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m24.0005-13.9999c-5.5225 0-10.0001-4.477-10.0001-9.9999 0-5.5225 4.4775-10.0001 10.0001-10.0001 5.5224 0 9.9999 4.4775 9.9999 10.0001 0 5.523-4.4775 9.9999-9.9999 9.9999z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m23.9998-4.0001c-11.0536 0-20-8.9474-20-20 0-11.0527 8.9464-20 20-20 11.0527 0 20 8.9473 20 20 0 11.0526-8.9474 20-20 20z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m37.9998-6.0001h-28c-2.211 0-4-1.791-4-4v-28c0-2.209 1.789-4 4-4h28c2.2109 0 4 1.791 4 4v28c0 2.2089-1.7891 4-4 4z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m39.9998-8.0001h-32c-2.209 0-4-1.791-4-4v-24c0-2.209 1.791-4 4-4h32c2.209 0 4.0001 1.7913 4.0001 4.0003l-.0001 23.9997c0 2.2089-1.7911 4-4 4z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "m39.9998-40.0001v32c0 2.209-1.791 4-4 4h-24c-2.209 0-4-1.791-4-4v-32c0-2.209 1.791-4 4-4h24c2.2089 0 4 1.791 4 4z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.75-.25v-47.5h-47.5v47.5zm.25.25h-48v-48h48z"
  }))))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "m0-48h48v48h-48z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backup",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 8.0005v-.0001c-.0001-.5523.4476-1 .9999-1.0001l14-.0008c.5523 0 1 .4476 1.0001.9999v.0001c0 .5524-.4477 1.0002-1 1.0002l-14 .0007c-.5522.0001-1-.4476-1-.9999z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 16.0005v-.0001c-.0001-.5523.4476-1.0001.9999-1.0001l14-.0008c.5523 0 1 .4476 1.0001.9999v.0001c0 .5524-.4477 1.0002-1 1.0002l-14 .0007c-.5522.0001-1-.4476-1-.9999z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    display: "inline",
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 16,
    display: "inline",
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none",
    transform: "scale(.5 -.5)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "XMLID_48_",
    display: "inline",
    height: 48,
    opacity: 0.15,
    width: 48,
    xlinkHref: "#material_x5F_system_x5F_icon_x5F_grid",
    y: -48
  }), /*#__PURE__*/React.createElement("use", {
    id: "XMLID_47_",
    display: "inline",
    height: 48,
    width: 48,
    xlinkHref: "#material_x5F_system_x5F_icon_x5F_border",
    y: -48
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Keyline",
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    id: "XMLID_14_",
    display: "inline",
    height: 48,
    transform: "scale(.5 -.5)",
    width: 48,
    xlinkHref: "#material_x5F_system_x5F_icon_x5F_keylines",
    y: -48
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19 6.9996-2.1837.0001c-.4135-1.1624-1.5121-1.9997-2.8163-1.9997-1.3043 0-2.403.8375-2.8163 2l-6.1837.0003c-.5523 0-1 .4478-1 1.0001v.0001c0 .5522.4478.9999 1 .9999l6.1837-.0003c.4133 1.1625 1.512 1.9999 2.8163 1.9999 1.3044 0 2.4032-.8375 2.8164-2.0002l2.1836-.0001c.5522-.0001 1-.4479 1-1.0001v-.0001c0-.5523-.4478-1-1-.9999zm-5 2.0004c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 14.9996-6.1837.0003c-.4134-1.1625-1.5121-1.9999-2.8163-1.9999-1.3044 0-2.4032.8375-2.8164 2.0002l-2.1836.0001c-.5523 0-1 .4478-1 1.0001v.0001c0 .5522.4478.9999 1 .9999l2.1838-.0001c.4134 1.1624 1.512 1.9997 2.8162 1.9997 1.3043 0 2.403-.8375 2.8163-2l6.1837-.0003c.5522 0 1-.4478 1-1.0001v-.0001c0-.5523-.4478-1-1-.9999zm-9 2.0004c-.5514 0-1-.4486-1-1s.4486-1 1-1 1 .4486 1 1-.4486 1-1 1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Filled",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.9999 6.9996-2.1838.0001c-.4133-1.1624-1.5119-1.9997-2.8161-1.9997-1.3043 0-2.403.8375-2.8163 2l-6.1838.0003c-.5523.0001-1 .4478-.9999 1.0001v.0001c.0001.5522.4478.9999 1 .9999l6.1837-.0003c.4133 1.1626 1.512 1.9999 2.8163 1.9999 1.3044 0 2.4031-.8376 2.8163-2.0002l2.1837-.0001c.5522-.0001 1-.4478.9999-1.0001v-.0001c0-.5523-.4477-1-1-.9999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.9999 14.9996-6.1837.0003c-.4132-1.1626-1.5119-1.9999-2.8162-1.9999-1.3044 0-2.4031.8376-2.8163 2.0002l-2.1837.0001c-.5523.0001-1 .4478-.9999 1.0001v.0001c.0001.5522.4478.9999 1 .9999l2.1838-.0001c.4133 1.1624 1.5119 1.9997 2.8161 1.9997 1.3043 0 2.403-.8375 2.8163-2l6.1838-.0003c.5522-.0001 1-.4478.9999-1.0001v-.0001c-.0001-.5523-.4478-1-1.0001-.9999z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Two_Tone",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4 8.0005v-.0001c-.0001-.5523.4476-1 .9999-1.0001l14-.0008c.5523 0 1 .4476 1.0001.9999v.0001c.0001.5523-.4476 1.0001-.9999 1.0001l-14 .0008c-.5523.0001-1-.4476-1.0001-.9999z",
    fill: "#00d6a2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4 16.0005v-.0001c-.0001-.5523.4476-1.0001.9999-1.0001l14-.0008c.5523 0 1 .4476 1.0001.9999v.0001c.0001.5523-.4476 1.0001-.9999 1.0001l-14 .0008c-.5523.0001-1-.4476-1.0001-.9999z",
    fill: "#00d6a2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 16,
    r: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8c66d4204f172e235759a4c70d946180.svg";
export { ForwardRef as ReactComponent };